import React, { Component } from "react";

class Order extends Component {
  render() {
    return <div className="order">Order!</div>;
  }
}

export default Order;



// WEBPACK FOOTER //
// ./src/components/Order.js